export default {
  collectors: state => state.collectors,
  userCollectors: state => state.userCollectors,
  timeouts: state => state.timeouts,
};
